import React from 'react';

// 카카오 OAuth는 서버(/api/auth/kakao)에서 시작해 REST API 키를 클라이언트에 노출하지 않는다.
// 개발 모드에서는 콜백이 localhost로 돌아오도록 dev=1을 붙인다.
const KAKAO_LOGIN_URL = process.env.NODE_ENV === 'development' ? '/api/auth/kakao?dev=1' : '/api/auth/kakao';

export function KakaoButton({ label }: { label: string }) {
  return (
    <a className="btn btn-kakao btn-block" href={KAKAO_LOGIN_URL}>
      <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
        <path
          fill="#000000"
          d="M9 1.5C4.58 1.5 1 4.32 1 7.8c0 2.24 1.49 4.2 3.73 5.32l-.95 3.48c-.08.3.26.54.52.37l4.15-2.75c.18.02.36.03.55.03 4.42 0 8-2.82 8-6.3S13.42 1.5 9 1.5z"
        />
      </svg>
      <span>{label}</span>
    </a>
  );
}
